/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: abo.js
 */
$.namespace("SCS.abo");

/**
 * Initialize abo (plan)
 */
SCS.abo.init = function() {
	$('.products').find('.shopping').each(function() {
		$(this).find('input:radio').each(function() {
			var $this = $(this);
			if (this.checked) {
				SCS.abo.getPrice($this);
			}
			$this.change(function() {
				if (this.checked) {
					SCS.abo.getPrice($(this));
				}
			});
		});
	});
};

/**
 * Get price
 * @param radio Radio button
 */
SCS.abo.getPrice = function(radio) {
	var priceDisplay = radio.closest('.shopping').find('.modPriceTag .price');
	priceDisplay.text(radio.data('price'));
};

/**
 * Initialize next button
 */
SCS.abo.initNextButton = function() {
	var nextButton = $('.products').find('.nextresults');
	var items = $('.products').find('.device');
	SCS.portal.initPaging(nextButton, items);
};

/**
 * Initialize
 */
SCS.ensure(function(context, $) {
	SCS.abo.init();
	SCS.abo.initNextButton();
}, 'body, .ui-tabs-panel');

/* Update form action and initialize tooltips in abo teasers */
SCS.ensure(function(context, $) {
	if (context.find('.scs-abo-teaser').length){
		if (SCS.product && typeof SCS.product.updateFormAction !== 'undefined') SCS.product.updateFormAction(context.find('.scs-abo-teaser form.scs-form'));

		$('.scs-abo-teaser .promo-tip').qtip();
	}
}, 'body, .ui-tabs-panel');



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/ecommerce/clientlibs/desktop/js/abo.js
// module id = 246
// module chunks = 0